import { createContext } from 'react';
import useSurvey from '../hooks/userSurveys';
export const SurveyContext = createContext({});

const SurveyContextProvider = ({children }) => {
    const surveyData = useSurvey();
    
    return (
        <SurveyContext.Provider value={surveyData}  >{ children }</SurveyContext.Provider>
    )
}

export default SurveyContextProvider;